import { render, staticRenderFns } from "./goods-vip-forever-protocol.vue?vue&type=template&id=141d47ea&scoped=true"
import script from "./goods-vip-forever-protocol.vue?vue&type=script&lang=js"
export * from "./goods-vip-forever-protocol.vue?vue&type=script&lang=js"
import style0 from "./goods-vip-forever-protocol.vue?vue&type=style&index=0&id=141d47ea&prod&lang=scss"
import style1 from "./goods-vip-forever-protocol.vue?vue&type=style&index=1&id=141d47ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141d47ea",
  null
  
)

export default component.exports